const usesRouter = {
  path: '/uses',
  name: 'uses',
  component: () => import('../views/UsesView.vue')
}

export { usesRouter }
